import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  CarRentalCategory,
  CarRentalConfig,
  CarRentalReservationRequest,
  CarRentalReservationStatus,
  CarRentalVehicle,
} from "../models/Experience/ExperienceModels";
import { StoreDomain } from "../models/Experience/ExperienceSharedModels";

class CarRentalApi extends BaseApi {
  public config = BaseApi.createEndpoint<CarRentalConfig, null>(HttpMethodEnum.GET, "/car-rental/config");
  public updateConfig = BaseApi.createEndpoint<CarRentalConfig, { config: Partial<CarRentalConfig> }>(
    HttpMethodEnum.PUT,
    "/car-rental/config",
  );
  public publish = BaseApi.createEndpoint<CarRentalConfig, { config: Partial<CarRentalConfig> }>(
    HttpMethodEnum.POST,
    "/car-rental/publish",
  );
  public categories = BaseApi.createEndpoint<CarRentalCategory[], null>(
    HttpMethodEnum.GET,
    "/car-rental/categories",
  );
  public createCategory = BaseApi.createEndpoint<CarRentalCategory, { category: Partial<CarRentalCategory> }>(
    HttpMethodEnum.POST,
    "/car-rental/categories",
  );
  public updateCategory = (id: string) =>
    BaseApi.createEndpoint<CarRentalCategory, { category: Partial<CarRentalCategory> }>(
      HttpMethodEnum.PUT,
      `/car-rental/categories/${id}`,
    );
  public deleteCategory = (id: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/car-rental/categories/${id}`);
  public vehicles = BaseApi.createEndpoint<CarRentalVehicle[], null>(HttpMethodEnum.GET, "/car-rental/vehicles");
  public createVehicle = BaseApi.createEndpoint<CarRentalVehicle, { vehicle: Partial<CarRentalVehicle> }>(
    HttpMethodEnum.POST,
    "/car-rental/vehicles",
  );
  public updateVehicle = (id: string) =>
    BaseApi.createEndpoint<CarRentalVehicle, { vehicle: Partial<CarRentalVehicle> }>(
      HttpMethodEnum.PUT,
      `/car-rental/vehicles/${id}`,
    );
  public deleteVehicle = (id: string) =>
    BaseApi.createEndpoint<boolean, null>(HttpMethodEnum.DELETE, `/car-rental/vehicles/${id}`);
  public domains = BaseApi.createEndpoint<StoreDomain[], null>(HttpMethodEnum.GET, "/car-rental/domains");
  public addDomain = BaseApi.createEndpoint<StoreDomain, { hostname: string }>(
    HttpMethodEnum.POST,
    "/car-rental/domains",
  );
  public verifyDomain = (hostname: string) =>
    BaseApi.createEndpoint<StoreDomain, null>(
      HttpMethodEnum.POST,
      `/car-rental/domains/${encodeURIComponent(hostname)}/verify`,
    );
  public reservations = BaseApi.createEndpoint<CarRentalReservationRequest[], null>(
    HttpMethodEnum.GET,
    "/car-rental/reservations",
  );
  public updateReservationStatus = (reservationId: string) =>
    BaseApi.createEndpoint<CarRentalReservationRequest, { status: CarRentalReservationStatus }>(
      HttpMethodEnum.PUT,
      `/car-rental/reservations/${reservationId}/status`,
    );
}

export const carRentalApi = new CarRentalApi();
